module.exports = "/fast-coin/img/coin/anim/in/coin_in_014.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/in/coin_in_014.png
// module id = 2284
// module chunks = 5